import { AbstractIconComponent } from '../abstract.icon'
import { Component } from '@angular/core'

@Component({
  selector: 'icon-ev-connector-type2',
  templateUrl: './ev-connector-type2.icon.html',
  styles: [
    `
      svg {
        width: 60px;
        height: 60px;
      }
    `,
  ],
})
export class EvConnectorType2Component extends AbstractIconComponent {
  static icon = 'ev-connector-type2'
}
